/* ============================================================
   47X · DASHBOARD FAM47 · /pages/atletas · 2026-06-03
   Estabilización V1 · cero features nuevas. Cambios:
     1. Hot update post-COMPLETE · sin location.reload()
     2. Cache localStorage del /state TTL 60s · render instantáneo en revisitas
     3. Skeleton loader CSS-only mientras carga
     4. apiCall() helper centralizado
     5. Estado de error visible si fetch falla
     6. Fallback de reveal 2500ms → 1500ms
     7. Fix label de COMPLETE (puntos sumados visibles)
     8. Fusión de 2 IIFE en uno · setSelection cruzado entre gate y complete
   Lee los datos Liquid desde data-* attrs del [data-atletas-dash]
   ============================================================ */
(function () {
  var gate = document.querySelector('[data-fam47-gate]');
  var dash = document.querySelector('[data-atletas-dash]');
  var skel = document.querySelector('[data-fam47-skel]');
  if (!dash) return;

  /* ===== Liquid → data-* (single source of truth) ===== */
  var CUSTOMER_ID    = dash.getAttribute('data-customer-id') || '';
  var CUSTOMER_EMAIL = dash.getAttribute('data-customer-email') || '';
  var CUSTOMER_FNAME = dash.getAttribute('data-customer-firstname') || '';
  var LOGIN_URL      = dash.getAttribute('data-login-url') || '/account/login';
  var STATE_TTL_MS   = 60 * 1000;          /* cache state 60s */
  var REVEAL_FALLBACK_MS = 1500;           /* antes 2500 */

  var STORAGE_UNLOCK = 'fam47:unlock:' + CUSTOMER_ID;
  var STORAGE_STATE  = 'fam47:state:'  + CUSTOMER_ID;

  /* ===== ▼▼▼ PASSWORD ROTATIVA v2 · 7 DIARIAS · INICIO · 2026-06-07 ▼▼▼ ===== */
  var CDMX_OFFSET_MS = -6 * 3600 * 1000;
  var PASSWORDS = {
    '2026-07-07': 'LLAMA47',
    '2026-07-08': 'TITAN47',
    '2026-07-09': 'LOBO47',
    '2026-07-10': 'FIERA47',
    '2026-07-11': 'RAYO47',
    '2026-07-12': 'TRUENO47',
    '2026-07-13': 'BRONCE47',
    '2026-07-14': 'VOLCAN47',
    '2026-07-15': 'LAVA47',
    '2026-07-16': 'CENIZA47',
    '2026-07-17': 'CHISPA47',
    '2026-07-18': 'BRASA47',
    '2026-07-19': 'YUNQUE47',
    '2026-07-20': 'MARTILLO47',
    '2026-07-21': 'CINCEL47',
    '2026-07-22': 'PIEDRA47',
    '2026-07-23': 'GRANITO47',
    '2026-07-24': 'MARMOL47',
    '2026-07-25': 'DIAMANTE47',
    '2026-07-26': 'CUARZO47',
    '2026-07-27': 'SELVA47',
    '2026-07-28': 'MONTE47',
    '2026-07-29': 'PICO47',
    '2026-07-30': 'CUMBRE47',
    '2026-07-31': 'RISCO47',
    '2026-08-01': 'MAREA47',
    '2026-08-02': 'TORMENTA47',
    '2026-08-03': 'RELAMPAGO47',
    '2026-08-04': 'ESCARCHA47',
    '2026-08-05': 'MAGMA47',
    '2026-08-06': 'NUCLEO47',
    '2026-08-07': 'COMETA47',
    '2026-08-08': 'METEORO47',
    '2026-08-09': 'ECLIPSE47',
    '2026-08-10': 'AURORA47',
    '2026-08-11': 'MUSCULO47',
    '2026-08-12': 'TENDON47',
    '2026-08-13': 'FIBRA47',
    '2026-08-14': 'ALIENTO47',
    '2026-08-15': 'LATIDO47',
    '2026-08-16': 'CORAJE47',
    '2026-08-17': 'TEMPLE47',
    '2026-08-18': 'IMPULSO47',
    '2026-08-19': 'ARRANQUE47',
    '2026-08-20': 'EMBATE47',
    '2026-08-21': 'ASALTO47',
    '2026-08-22': 'FURIA47',
    '2026-08-23': 'RABIA47',
    '2026-08-24': 'BRIO47',
    '2026-08-25': 'VIGOR47',
    '2026-08-26': 'POTENCIA47',
    '2026-08-27': 'FUERZA47',
    '2026-08-28': 'VOLUNTAD47',
    '2026-08-29': 'TESON47',
    '2026-08-30': 'AGUANTE47',
    '2026-08-31': 'TENAZ47'
  };
  function normPwd(s) {
    s = String(s || '').trim().toUpperCase();
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return s;
  }
  function cdmxDateKey() {
    return new Date(Date.now() + CDMX_OFFSET_MS).toISOString().slice(0, 10);
  }
  function currentPassword() {
    var p = PASSWORDS[cdmxDateKey()];
    return p ? normPwd(p) : null;
  }
  function isPasswordValid(typed) {
    var p = currentPassword();
    return !!p && normPwd(typed) === p;
  }
  function currentKey() {
    return 'd' + cdmxDateKey();
  }
  /* ===== ▲▲▲ PASSWORD ROTATIVA v2 · 7 DIARIAS · FIN ▲▲▲ ===== */
  function readUnlockCache() {
    try {
      var raw = localStorage.getItem(STORAGE_UNLOCK);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (obj && typeof obj.key === 'string') return obj;
    } catch (e) {}
    return null;
  }
  function writeUnlockCache(k, id) {
    try { localStorage.setItem(STORAGE_UNLOCK, JSON.stringify({ key: k, id: id })); } catch (e) {}
  }
  function sanitizeId(raw) {
    if (!raw) return '';
    var s = String(raw).trim().toUpperCase();
    s = s.replace(/[^A-Z0-9._-]/g, '');
    return s.slice(0, 20);
  }

  /* ===== Cache del state (TTL 60s) ===== */
  function readStateCache() {
    try {
      var raw = localStorage.getItem(STORAGE_STATE);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (obj && obj.at && (Date.now() - obj.at < STATE_TTL_MS) && obj.state) return obj.state;
    } catch (e) {}
    return null;
  }
  function writeStateCache(state) {
    try { localStorage.setItem(STORAGE_STATE, JSON.stringify({ at: Date.now(), state: state })); } catch (e) {}
  }
  function invalidateStateCache() {
    try { localStorage.removeItem(STORAGE_STATE); } catch (e) {}
  }

  /* ===== apiCall helper · cero duplicación de headers/credentials ===== */
  function apiCall(endpoint, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = options.headers || {};
    options.headers['Accept'] = 'application/json';
    if (options.body && !options.headers['Content-Type']) {
      options.headers['Content-Type'] = 'application/json';
    }
    var _sep = endpoint.indexOf('?') === -1 ? '?' : '&';
    var _url = '/apps/atletas/' + endpoint + (window.FAM47_TOKEN ? _sep + 'atleta_token=' + encodeURIComponent(window.FAM47_TOKEN) : '');
    return fetch(_url, options)
      .then(function (r) {
        return r.json().then(function (body) {
          return { status: r.status, ok: r.ok, body: body };
        });
      });
  }

  /* ===== Niveles (espejo del backend · invariante) ===== */
  var LEVELS = [
    { orden: 1, name: 'RENACER',    req: 0 },
    { orden: 2, name: 'EMERGER',    req: 300 },
    { orden: 3, name: 'CONQUISTAR', req: 800 },
    { orden: 4, name: 'ELITE',      req: 1800 }
  ];
  function getNivel(puntos) {
    var current = LEVELS[0], next = LEVELS[1] || null;
    for (var i = 0; i < LEVELS.length; i++) {
      if (puntos >= LEVELS[i].req) {
        current = LEVELS[i];
        next = LEVELS[i + 1] || null;
      }
    }
    return { current: current, next: next };
  }
  function setText(sel, val) {
    var el = document.querySelector(sel);
    if (el) el.textContent = val;
  }
  function applyName(id) {
    if (!id) return;
    var nameEls = document.querySelectorAll('[data-fam47-name]');
    for (var i = 0; i < nameEls.length; i++) nameEls[i].textContent = id;
  }
  function applyXpBar(puntos) {
    var fill = document.querySelector('[data-atletas-xpfill]');
    var bar  = document.querySelector('[data-atletas-xpbar]');
    var labelEl  = document.querySelector('[data-atletas-xp-label]');
    var nextEl   = document.querySelector('[data-atletas-xp-next]');
    var nivelNum = document.querySelector('[data-atletas-nivel-num]');
    var nivelName = document.querySelectorAll('[data-atletas-nivel-name]');
    if (!fill || !bar) return;
    var lv = getNivel(puntos);
    var pct, label, nextLabel;
    if (lv.next) {
      var span = lv.next.req - lv.current.req;
      var rel = puntos - lv.current.req;
      pct = span > 0 ? Math.max(0, Math.min(100, Math.round((rel / span) * 100))) : 0;
      var falta = lv.next.req - puntos;
      if (falta < 0) falta = 0;
      if (puntos < lv.next.req) {
        label = lv.current.name + ' · ' + rel + '/' + span + ' XP';
        nextLabel = '→ Te faltan ' + falta + ' XP para ' + lv.next.name;
      } else {
        label = lv.current.name + ' · ' + rel + '/' + span + ' XP';
        nextLabel = '→ ' + lv.next.name;
      }
    } else {
      pct = 100;
      label = 'NIVEL MÁXIMO · ' + puntos + ' XP';
      nextLabel = '★ ELITE alcanzado';
    }
    if (nivelNum) nivelNum.textContent = 'LV. ' + lv.current.orden;
    for (var i = 0; i < nivelName.length; i++) nivelName[i].textContent = lv.current.name;
    if (labelEl) labelEl.textContent = label;
    if (nextEl) nextEl.textContent = nextLabel;
    updateNiveles(puntos);
    renderBadges();
    bar.setAttribute('aria-valuenow', String(pct));
    fill.style.setProperty('--pct', '0%');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fill.style.setProperty('--pct', pct + '%');
      });
    });
  }

  /* ===== FIX · recalcula las ZONAS de nivel en cliente (el SSR queda estático) ===== */
  function updateNiveles(puntos) {
    var cards = document.querySelectorAll('.atletas-dash__lvl');
    if (!cards.length) return;
    puntos = puntos || 0;
    var i, req, currentReq = -1;
    /* nivel actual = mayor umbral <= puntos */
    for (i = 0; i < cards.length; i++) {
      req = parseInt(cards[i].getAttribute('data-nivel-req'), 10) || 0;
      if (puntos >= req && req > currentReq) currentReq = req;
    }
    var curName = '';
    for (i = 0; i < cards.length; i++) {
      var card = cards[i];
      req = parseInt(card.getAttribute('data-nivel-req'), 10) || 0;
      var state = req === currentReq ? 'actual' : (puntos >= req ? 'unlocked' : 'lock');
      if (state === 'actual') curName = card.getAttribute('data-nivel-name') || '';
      card.classList.remove('atletas-dash__lvl--actual', 'atletas-dash__lvl--unlocked', 'atletas-dash__lvl--lock');
      card.classList.add('atletas-dash__lvl--' + state);
      var pin = card.querySelector('.atletas-dash__lvl-pin');
      if (pin) {
        pin.classList.remove('atletas-dash__lvl-pin--past', 'atletas-dash__lvl-pin--lock');
        if (state === 'actual') { pin.textContent = '▸ TU NIVEL'; }
        else if (state === 'unlocked') { pin.textContent = '✓ DESBLOQUEADO'; pin.classList.add('atletas-dash__lvl-pin--past'); }
        else { pin.textContent = '▢ ' + (req - puntos) + ' PTS PARA DESBLOQUEAR'; pin.classList.add('atletas-dash__lvl-pin--lock'); }
      }
      var cta = card.querySelector('.atletas-dash__lvl-cta');
      if (cta) cta.style.display = (state !== 'lock' && card.getAttribute('data-nivel-url')) ? '' : 'none';
    }
    var curEl = document.querySelector('[data-niveles-cur]');
    if (curEl && curName) curEl.textContent = curName;
  }

  /* ===== desplegable de la sección "SISTEMA DE NIVELES" (ahorra espacio) ===== */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-niveles-toggle]');
    if (!t) return;
    var sec = t.closest('.atletas-dash__niveles');
    if (!sec) return;
    var collapsed = sec.classList.toggle('is-collapsed');
    t.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  });

  /* ===== desplegable GENÉRICO (BIO / SEMANA · mismo patrón que Niveles) ===== */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-collapse-toggle]');
    if (!t) return;
    var sec = t.closest('[data-collapse]');
    if (!sec) return;
    var collapsed = sec.classList.toggle('is-collapsed');
    t.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  });

  /* ===== V1.4 · Pre-launch teaser countdown ===== */
  function teaserMs(iso) {
    if (!iso) return -1;
    /* ISO local sin Z · interpretar como hora local del browser */
    var s = String(iso);
    /* Si no tiene segundos, agregar :00 */
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(s)) s = s + ':00';
    var t = Date.parse(s);
    if (isNaN(t)) return -1;
    return t - Date.now();
  }
  function formatTeaserCountdown(ms) {
    if (ms <= 0) return '00:00:00';
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var m = Math.floor(s / 60);
    var sec = s - m * 60;
    if (d > 0) return d + 'd ' + pad2(h) + ':' + pad2(m) + ':' + pad2(sec);
    return pad2(h) + ':' + pad2(m) + ':' + pad2(sec);
  }
  var _teaserTimer = null;
  function initTeaser() {
    var box = document.querySelector('[data-atletas-teaser]');
    if (!box) return;
    var iso = box.getAttribute('data-teaser-iso');
    var timeEl = box.querySelector('[data-atletas-teaser-time]');
    if (!iso || !timeEl) return;
    function tick() {
      var ms = teaserMs(iso);
      if (ms <= 1000) {
        timeEl.textContent = '00:00:00';
        box.hidden = true;
        if (_teaserTimer) { clearInterval(_teaserTimer); _teaserTimer = null; }
        return;
      }
      timeEl.textContent = formatTeaserCountdown(ms);
    }
    tick();
    if (teaserMs(iso) > 1000) {
      box.hidden = false;
      if (_teaserTimer) clearInterval(_teaserTimer);
      _teaserTimer = setInterval(tick, 1000);
    }
  }

  /* ===== V1.3 · Countdown · ms hasta 6:30 AM CDMX (= 12:30 UTC) ===== */
  function nextResetMs() {
    var now = Date.now();
    var d = new Date(now);
    var todayTarget = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 12, 30, 0);
    if (now < todayTarget) return todayTarget - now;
    var tomorrowTarget = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + 1, 12, 30, 0);
    return tomorrowTarget - now;
  }
  function pad2(n) { return n < 10 ? '0' + n : '' + n; }
  function formatCountdown(ms) {
    if (ms <= 0) return '00:00:00';
    var s = Math.floor(ms / 1000);
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60);
    var sec = s - m * 60;
    return pad2(h) + ':' + pad2(m) + ':' + pad2(sec);
  }
  var _countdownTimer = null;
  function startCountdown() {
    var box = document.querySelector('[data-atletas-countdown]');
    if (!box) return;
    var timeEl = box.querySelector('[data-atletas-countdown-time]');
    if (!timeEl) return;
    box.hidden = false;
    if (_countdownTimer) clearInterval(_countdownTimer);
    function tick() {
      var ms = nextResetMs();
      if (ms <= 1000) {
        timeEl.textContent = '00:00:00';
        clearInterval(_countdownTimer);
        return;
      }
      timeEl.textContent = formatCountdown(ms);
    }
    tick();
    _countdownTimer = setInterval(tick, 1000);
  }
  function stopCountdown() {
    if (_countdownTimer) { clearInterval(_countdownTimer); _countdownTimer = null; }
    var box = document.querySelector('[data-atletas-countdown]');
    if (box) box.hidden = true;
  }
  function maybeShowCountdown() {
    var retoEl = document.querySelector('[data-atletas-reto]');
    if (retoEl && retoEl.classList.contains('is-done')) startCountdown();
    else stopCountdown();
  }

  /* ===== V1.3 · Próximo logro · parsea logros bloqueados, pickea el más cercano ===== */
  function pickNextAch(s) {
    var retosCount = (s.retos_completados && s.retos_completados.length) || 0;
    var nodes = document.querySelectorAll('[data-ach]');
    var best = null;
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.classList.contains('is-unlocked')) continue;
      var cond = n.getAttribute('data-ach-condition') || '';
      var nameEl = n.querySelector('.atletas-dash__ach-name');
      var iconEl = n.querySelector('.atletas-dash__ach-icon');
      var name = nameEl ? nameEl.textContent.trim() : '';
      var icon = iconEl ? iconEl.textContent.trim() : '◢';
      var entry = null;
      if (cond === 'mes') {
        entry = { name: name, icon: icon, falta: 0, pct: s.mes_actual_completo ? 100 : 50, type: 'mes', faltaTxt: 'Completa todos los días del mes' };
      } else {
        var m = cond.match(/^(puntos|racha|retos)>=(\d+)$/);
        if (!m) continue;
        var key = m[1], thr = parseInt(m[2], 10);
        var val = key === 'puntos' ? (s.puntos || 0)
                : key === 'racha'  ? (s.racha || 0)
                : retosCount;
        var falta = thr - val;
        if (falta <= 0) continue;
        var pct = Math.max(0, Math.min(100, Math.round((val / thr) * 100)));
        var faltaTxt = '';
        if (key === 'puntos') faltaTxt = 'A ' + falta + ' XP de desbloquear';
        else if (key === 'racha') faltaTxt = 'A ' + falta + ' día' + (falta === 1 ? '' : 's') + ' de racha';
        else faltaTxt = 'A ' + falta + ' reto' + (falta === 1 ? '' : 's') + ' de desbloquear';
        entry = { name: name, icon: icon, falta: falta, pct: pct, faltaTxt: faltaTxt };
      }
      if (entry && (!best || entry.pct > best.pct)) best = entry;
    }
    return best;
  }
  function applyNextAch(s) {
    var box = document.querySelector('[data-atletas-next-ach]');
    if (!box) return;
    var next = pickNextAch(s);
    if (!next) {
      box.hidden = true;
      return;
    }
    box.hidden = false;
    var nameEl = box.querySelector('[data-atletas-next-ach-name]');
    var faltaEl = box.querySelector('[data-atletas-next-ach-falta]');
    var iconEl = box.querySelector('[data-atletas-next-ach-icon]');
    var barEl = box.querySelector('[data-atletas-next-ach-bar]');
    if (nameEl) nameEl.textContent = next.name;
    if (faltaEl) faltaEl.textContent = next.faltaTxt;
    if (iconEl) iconEl.textContent = next.icon;
    if (barEl) {
      barEl.style.setProperty('--pct', '0%');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { barEl.style.setProperty('--pct', next.pct + '%'); });
      });
    }
  }

  /* ===== V1.3 · Streak forecast · qué pasa si marcas mañana ===== */
  function setStreakForecast(racha) {
    var box = document.querySelector('[data-atletas-forecast]');
    if (!box) return;
    var txt = box.querySelector('[data-atletas-forecast-txt]');
    if (!txt) return;
    var msg;
    if (!racha || racha === 0) {
      msg = 'Marca hoy · mañana llegas a 1d · empieza tu racha';
    } else if (racha < 3) {
      var fa = 3 - racha;
      msg = 'Mañana llegas a ' + (racha + 1) + 'd · ' + (fa === 1 ? 'mañana mismo' : 'en ' + fa + ' días') + ' alcanzas RACHA 3 DÍAS';
    } else if (racha < 7) {
      var fa = 7 - racha;
      msg = 'Mañana llegas a ' + (racha + 1) + 'd · ' + (fa === 1 ? 'mañana mismo' : 'en ' + fa + ' días') + ' alcanzas SEMANA PERFECTA';
    } else if (racha < 14) {
      var fa = 14 - racha;
      msg = 'Mañana llegas a ' + (racha + 1) + 'd · ' + (fa === 1 ? 'mañana mismo' : 'en ' + fa + ' días') + ' alcanzas QUINCENA';
    } else if (racha < 30) {
      var fa = 30 - racha;
      msg = 'Mañana llegas a ' + (racha + 1) + 'd · ' + (fa === 1 ? 'mañana mismo' : 'en ' + fa + ' días') + ' desbloqueas PRENDA SORPRESA (30d)';
    } else {
      msg = '★ ' + racha + 'd al hilo · cada día que sumes te separa más del resto';
    }
    txt.textContent = msg;
  }

  /* ===== V1.3 · Actualiza el bloque "Próximo desbloqueo" (next-bene) ===== */
  function applyNextBene(currentLevelName) {
    var box = document.querySelector('[data-atletas-next-bene]');
    if (!box) return;
    /* Identificar siguiente nivel desde LEVELS */
    var idx = -1;
    for (var i = 0; i < LEVELS.length; i++) {
      if (LEVELS[i].name === currentLevelName) { idx = i; break; }
    }
    var nameEl = box.querySelector('[data-atletas-next-bene-name]');
    var txtEl  = box.querySelector('[data-atletas-next-bene-txt]');
    var eyebrowEl = box.querySelector('.atletas-dash__next-bene-eyebrow');
    var iconEl    = box.querySelector('.atletas-dash__next-bene-icon');
    if (idx < 0 || idx >= LEVELS.length - 1) {
      /* máximo · ELITE alcanzado */
      if (eyebrowEl) eyebrowEl.textContent = '▸ NIVEL MÁXIMO';
      if (nameEl) nameEl.textContent = 'ELITE alcanzado';
      if (txtEl) txtEl.textContent = 'Ya disfrutas todos los beneficios FAM47.';
      if (iconEl) iconEl.textContent = '✦';
      return;
    }
    var nextLvl = LEVELS[idx + 1];
    var lvlCard = document.querySelector('.atletas-dash__lvl[data-nivel-name="' + nextLvl.name + '"]');
    var bene = '';
    if (lvlCard) {
      var beneEl = lvlCard.querySelector('.atletas-dash__lvl-bene');
      if (beneEl) bene = beneEl.textContent.trim();
    }
    if (eyebrowEl) eyebrowEl.textContent = '▸ PRÓXIMO DESBLOQUEO';
    if (nameEl) nameEl.textContent = nextLvl.name;
    if (txtEl) txtEl.textContent = bene || 'Sigue completando retos para desbloquear el siguiente nivel.';
    if (iconEl) iconEl.textContent = '★';
  }

  /* ===== V1.2 · Count-up animation (XP + RACHA) ===== */
  function countUp(el, from, to, dur) {
    if (!el) return;
    from = parseInt(from, 10) || 0;
    to = parseInt(to, 10) || 0;
    if (from === to) { el.textContent = String(to); return; }
    var start = performance.now();
    function tick(now) {
      var t = Math.min(1, (now - start) / dur);
      /* ease-out cubic */
      var eased = 1 - Math.pow(1 - t, 3);
      var val = Math.round(from + (to - from) * eased);
      el.textContent = String(val);
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ===== V1.2 · Racha · escala de fuego ===== */
  function setRachaLevel(racha) {
    var statRa = document.querySelector('[data-atletas-stat-racha]');
    if (!statRa) return;
    var lvl = 'none';
    if (racha >= 30) lvl = 'elite';
    else if (racha >= 7) lvl = 'fire';
    else if (racha >= 3) lvl = 'hot';
    else if (racha >= 1) lvl = 'active';
    statRa.setAttribute('data-racha-level', lvl);
    var flame = statRa.querySelector('[data-atletas-racha-flame]');
    if (flame) flame.hidden = (lvl === 'none');
  }

  /* ===== V1.2 · XP bar highlight glow post-update ===== */
  function pulseXpBar() {
    var fill = document.querySelector('[data-atletas-xpfill]');
    if (!fill) return;
    fill.classList.remove('is-just-grew');
    void fill.offsetWidth;
    fill.classList.add('is-just-grew');
    setTimeout(function () { fill.classList.remove('is-just-grew'); }, 1600);
  }

  /* ===== V1.2 · Reto card success transition ===== */
  function pulseRetoCard(retoEl) {
    if (!retoEl) return;
    retoEl.classList.add('is-just-done');
    setTimeout(function () { retoEl.classList.remove('is-just-done'); }, 1600);
  }

  /* ===== V1.2 · Logros · snapshot + detección + burst + toast ===== */
  function snapshotAchievements() {
    var snap = {};
    document.querySelectorAll('[data-ach]').forEach(function (n) {
      snap[n.getAttribute('data-ach')] = n.classList.contains('is-unlocked');
    });
    return snap;
  }
  function detectNewAchievements(snapBefore) {
    var newly = [];
    document.querySelectorAll('[data-ach]').forEach(function (n) {
      var id = n.getAttribute('data-ach');
      if (!snapBefore[id] && n.classList.contains('is-unlocked')) {
        var nameEl = n.querySelector('.atletas-dash__ach-name');
        newly.push({
          name: nameEl ? nameEl.textContent.trim() : id,
          node: n
        });
      }
    });
    return newly;
  }
  function celebrateAchievement(ach) {
    if (!ach || !ach.node) return;
    ach.node.classList.add('is-just-unlocked');
    setTimeout(function () { ach.node.classList.remove('is-just-unlocked'); }, 1200);
    spawnAchToast(ach.name);
  }
  var _achToastTimers = [];
  function spawnAchToast(name) {
    var t = document.createElement('div');
    t.className = 'ach-toast';
    t.innerHTML = '<span class="ach-toast__mark">✓</span>' +
      '<span class="ach-toast__body">' +
        '<span class="ach-toast__eyebrow">▸ NUEVO LOGRO</span>' +
        '<span class="ach-toast__name">' + name + '</span>' +
      '</span>';
    document.body.appendChild(t);
    void t.offsetWidth;
    t.classList.add('is-open');
    var tm = setTimeout(function () {
      t.classList.remove('is-open');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 350);
    }, 3500);
    _achToastTimers.push(tm);
  }

  /* ===== V1.2 · Level-up burst overlay + confetti CSS ===== */
  function spawnLevelBurst(level) {
    if (!level) return;
    var burst = document.createElement('div');
    burst.className = 'lvl-up-burst';
    burst.setAttribute('aria-hidden', 'true');
    burst.innerHTML =
      '<div class="lvl-up-burst__rays" aria-hidden="true"></div>' +
      '<div class="lvl-up-burst__badge">' +
        '<span class="lvl-up-burst__eyebrow">★ NIVEL DESBLOQUEADO ★</span>' +
        '<span class="lvl-up-burst__lvl">LV. ' + level.orden + '</span>' +
        '<span class="lvl-up-burst__name">' + level.name + '</span>' +
      '</div>';
    /* confetti partículas */
    var colors = ['#fcd34d', '#f59e0b', '#fff', '#34d399', '#fde68a'];
    for (var i = 0; i < 36; i++) {
      var p = document.createElement('span');
      p.className = 'lvl-up-confetti';
      p.style.background = colors[i % colors.length];
      p.style.left = (Math.random() * 100) + '%';
      p.style.animationDelay = (Math.random() * 0.5) + 's';
      p.style.animationDuration = (1.4 + Math.random() * 0.9) + 's';
      p.style.transform = 'rotate(' + (Math.random() * 360) + 'deg)';
      burst.appendChild(p);
    }
    document.body.appendChild(burst);
    setTimeout(function () { if (burst.parentNode) burst.parentNode.removeChild(burst); }, 2400);
  }

  /* ===== V1.1 · Celebración al COMPLETE ===== */
  function spawnFloat(targetEl, text, variant) {
    if (!targetEl) return;
    var rect = targetEl.getBoundingClientRect();
    var el = document.createElement('span');
    el.className = 'atletas-dash__float' + (variant ? ' atletas-dash__float--' + variant : '');
    el.textContent = text;
    el.style.left = (rect.left + rect.width / 2) + 'px';
    el.style.top  = (rect.top - 8) + 'px';
    document.body.appendChild(el);
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 1500);
  }
  function celebrate(deltaXp, deltaRacha) {
    if (!dash) return;
    dash.classList.add('atletas-dash--celebrate');
    setTimeout(function () { dash.classList.remove('atletas-dash--celebrate'); }, 750);
    var xpStat = document.querySelector('[data-atletas-stat-xp] [data-atletas-puntos]');
    var raStat = document.querySelector('[data-atletas-stat-racha] [data-atletas-racha]');
    if (deltaXp > 0 && xpStat) spawnFloat(xpStat, '+' + deltaXp + ' XP');
    if (deltaRacha > 0 && raStat) spawnFloat(raStat, '+' + deltaRacha + 'd', 'racha');
  }

  /* ===== V1.1 · Toast Level-Up ===== */
  function readNivelBene(nombre) {
    if (!nombre) return '';
    var card = document.querySelector('.atletas-dash__lvl[data-nivel-name="' + nombre + '"] .atletas-dash__lvl-bene');
    return card ? card.textContent.trim() : '';
  }
  /* V1.4 · URL del beneficio desde data-nivel-url de la card SSR */
  function readNivelUrl(nombre) {
    if (!nombre) return '';
    var card = document.querySelector('.atletas-dash__lvl[data-nivel-name="' + nombre + '"]');
    return card ? (card.getAttribute('data-nivel-url') || '') : '';
  }
  var _lvlToastTimer = null;
  function showLevelUpToast(newLevel) {
    var toast = document.querySelector('[data-lvl-up]');
    if (!toast || !newLevel) return;
    var nameEl = toast.querySelector('[data-lvl-up-name]');
    var beneEl = toast.querySelector('[data-lvl-up-bene]');
    if (nameEl) nameEl.textContent = newLevel.name;
    var bene = readNivelBene(newLevel.name);
    if (beneEl) beneEl.textContent = bene || 'Sigue ganando XP para más beneficios.';
    /* V1.4 · CTA APLICAR BENEFICIO en el toast (solo si hay URL config) */
    var ctaEl = toast.querySelector('[data-lvl-up-cta]');
    var nivelUrl = readNivelUrl(newLevel.name);
    if (ctaEl) {
      if (nivelUrl) {
        ctaEl.hidden = false;
        ctaEl.setAttribute('href', nivelUrl);
        var ctaTxt = ctaEl.querySelector('[data-lvl-up-cta-txt]');
        if (ctaTxt) ctaTxt.textContent = 'Aplicar beneficio ' + newLevel.name;
      } else {
        ctaEl.hidden = true;
      }
    }
    toast.hidden = false;
    void toast.offsetWidth;
    toast.classList.add('is-open');
    if (_lvlToastTimer) clearTimeout(_lvlToastTimer);
    _lvlToastTimer = setTimeout(closeLevelUpToast, 6000);
  }
  function closeLevelUpToast() {
    var toast = document.querySelector('[data-lvl-up]');
    if (!toast) return;
    toast.classList.remove('is-open');
    setTimeout(function () { if (!toast.classList.contains('is-open')) toast.hidden = true; }, 360);
  }
  function detectLevelUp(oldPuntos, newPuntos) {
    if (newPuntos <= oldPuntos) return null;
    var crossed = null;
    for (var i = 1; i < LEVELS.length; i++) {
      if (oldPuntos < LEVELS[i].req && newPuntos >= LEVELS[i].req) {
        crossed = LEVELS[i];
      }
    }
    return crossed;
  }
  /* Click handler · cerrar toast */
  document.addEventListener('click', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest('[data-lvl-up-close]')) {
      ev.preventDefault();
      closeLevelUpToast();
    }
  });
  /* ===== INSIGNIAS · se pintan en la ficha según XP (nivel) y récord de racha ===== */
  function badgeNum(sel) { var e = document.querySelector(sel); if (!e) return 0; var t = (e.textContent || '').replace(/[^0-9]/g, ''); return t ? parseInt(t, 10) : 0; }
  var BADGE_DEFS = [
    { ic: '🌱', n: 'RENACER', need: 0, by: 'xp' },
    { ic: '🥉', n: 'EMERGER', need: 300, by: 'xp' },
    { ic: '🥈', n: 'CONQUISTAR', need: 800, by: 'xp' },
    { ic: '👑', n: 'ELITE', need: 1800, by: 'xp' },
    { ic: '🔥', n: 'RACHA 7', need: 7, by: 'racha' },
    { ic: '⚡', n: 'RACHA 30', need: 30, by: 'racha' },
    { ic: '🏆', n: 'RACHA 100', need: 100, by: 'racha' }
  ];
  function renderBadges() {
    var box = document.querySelector('[data-atletas-badges]');
    if (!box) return;
    var xp = badgeNum('[data-atletas-stat-xp] [data-atletas-puntos]') || badgeNum('[data-atletas-puntos]');
    var rec = badgeNum('[data-atletas-record]') || badgeNum('[data-atletas-stat-racha] [data-atletas-racha]') || badgeNum('[data-atletas-racha]');
    var html = '';
    for (var i = 0; i < BADGE_DEFS.length; i++) {
      var d = BADGE_DEFS[i], have = d.by === 'xp' ? xp : rec, on = have >= d.need;
      html += '<span class="atletas-dash__badge ' + (on ? 'is-on' : 'is-off') + '" title="' + d.n + (on ? '' : ' · bloqueada') + '">' +
              '<span class="atletas-dash__badge-ic" aria-hidden="true">' + d.ic + '</span>' +
              '<span class="atletas-dash__badge-tx">' + d.n + '</span></span>';
    }
    box.innerHTML = html;
  }

  function applyBioStats(s) {
    var dias = (s.retos_completados && s.retos_completados.length) ? s.retos_completados.length : 0;
    setText('[data-atletas-dias]', dias);
    setText('[data-bio-sum]', dias + (dias === 1 ? ' día activo' : ' días activos'));
    setText('[data-atletas-record]', s.racha != null ? s.racha : 0);
    var promedio = dias > 0 ? Math.round((s.puntos || 0) / dias) : 0;
    setText('[data-atletas-promedio]', promedio);
    var mesStat = document.querySelector('[data-atletas-mes-stat]');
    if (mesStat) mesStat.hidden = !s.mes_actual_completo;
    var bannerRacha = document.querySelector('[data-atletas-banner-racha]');
    if (bannerRacha) bannerRacha.hidden = !(s.racha != null && s.racha >= 30);
    /* V1.2 · escala de fuego del stat racha */
    setRachaLevel(s.racha != null ? s.racha : 0);
    renderBadges();
  }
  function applyAchievements(s) {
    var retosCount = (s.retos_completados && s.retos_completados.length) || 0;
    var nodes = document.querySelectorAll('[data-ach]');
    for (var i = 0; i < nodes.length; i++) {
      var cond = nodes[i].getAttribute('data-ach-condition') || '';
      var unlocked = false;
      if (cond === 'mes') unlocked = !!s.mes_actual_completo;
      else {
        var m = cond.match(/^(puntos|racha|retos)>=(\d+)$/);
        if (m) {
          var key = m[1], thr = parseInt(m[2], 10);
          var val = key === 'puntos' ? s.puntos
                  : key === 'racha'  ? s.racha
                  : retosCount;
          unlocked = (val != null) && val >= thr;
        }
      }
      nodes[i].classList.toggle('is-unlocked', unlocked);
    }
    /* V2.5 mobile accordion · actualizar contadores del toggle */
    updateAchToggleMeta();
  }

  /* ===== V2.5 mobile · accordion LOGROS · counters + toggle handler ===== */
  function updateAchToggleMeta() {
    var total = document.querySelectorAll('[data-ach]').length;
    var unlocked = document.querySelectorAll('[data-ach].is-unlocked').length;
    var locked = total - unlocked;
    var uEl = document.querySelector('[data-atletas-ach-unlocked-count]');
    var lEl = document.querySelector('[data-atletas-ach-locked-count]');
    if (uEl) uEl.textContent = unlocked;
    if (lEl) lEl.textContent = locked;
  }
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest && ev.target.closest('[data-atletas-ach-toggle]');
    if (!t) return;
    ev.preventDefault();
    var section = t.closest('[data-atletas-ach-section]');
    if (!section) return;
    var isOpen = section.classList.toggle('is-open');
    t.setAttribute('aria-expanded', String(isOpen));
    var cta = t.querySelector('[data-atletas-ach-toggle-cta]');
    if (cta) cta.textContent = isOpen ? 'Cerrar ↑' : 'Ver →';
  });
  function todayCdmxIso() {
    return new Date(Date.now() - 6 * 3600 * 1000).toISOString().slice(0, 10);
  }
  function applyRetoDoneCard(doneEntry) {
    var retoArticle = document.querySelector('[data-atletas-reto]');
    if (!retoArticle) return;
    retoArticle.classList.add('is-done');
    var pts = doneEntry.puntos != null ? doneEntry.puntos : 0;
    var ttl = doneEntry.titulo;
    var dsc = doneEntry.descripcion;
    var ptsEl = retoArticle.querySelector('.atletas-dash__reto-pts');
    if (ptsEl) ptsEl.textContent = '+' + pts + ' XP';
    if (ttl) {
      var titleEl = retoArticle.querySelector('.atletas-dash__reto-title');
      if (titleEl) titleEl.textContent = ttl;
    }
    if (dsc) {
      var descEl = retoArticle.querySelector('.atletas-dash__reto-desc');
      if (descEl) descEl.textContent = dsc;
    }
    var btn = retoArticle.querySelector('[data-atletas-complete]');
    if (btn) btn.remove();
    if (!retoArticle.querySelector('.atletas-dash__reto-done')) {
      var done = document.createElement('div');
      done.className = 'atletas-dash__reto-done';
      done.innerHTML = '<span class="atletas-dash__reto-done-mark">✓</span>' +
        '<span>COMPLETADO HOY · +' + pts + ' XP SUMADOS</span>';
      var fine = retoArticle.querySelector('.atletas-dash__reto-fine');
      if (fine) retoArticle.insertBefore(done, fine);
      else retoArticle.appendChild(done);
    }
    var fineEl = retoArticle.querySelector('.atletas-dash__reto-fine');
    if (fineEl) fineEl.textContent = '▸ ✓ Tu racha sigue activa · vuelve mañana';
    /* V1.3 · activa el countdown HH:MM:SS hasta el siguiente reto */
    startCountdown();
  }
  function applyState(s) {
    if (!s) return;
    setText('[data-atletas-puntos]', s.puntos != null ? s.puntos : 0);
    setText('[data-atletas-racha]', s.racha != null ? s.racha : 0);
    applyXpBar(s.puntos || 0);
    applyBioStats(s);
    applyAchievements(s);
    /* V1.3 · objetivos dinámicos */
    applyNextAch(s);
    setStreakForecast(s.racha != null ? s.racha : 0);
    var curLv = getNivel(s.puntos || 0);
    applyNextBene(curLv.current.name);
    if (s.retos_completados && s.retos_completados.length) {
      var todayIso = todayCdmxIso();
      var doneEntry = null;
      for (var i = 0; i < s.retos_completados.length; i++) {
        if (s.retos_completados[i].date === todayIso) { doneEntry = s.retos_completados[i]; break; }
      }
      if (doneEntry) applyRetoDoneCard(doneEntry);
    }
    maybeShowCountdown();
    revealReto();
    hideError();
  }
  function revealReto() {
    var r = document.querySelector('[data-atletas-reto]');
    if (r) r.classList.remove('is-resolving');
  }

  /* ===== Error visible si fetch falla (en vez de pantalla muda) ===== */
  function showError(msg) {
    var box = document.querySelector('[data-fam47-fetch-err]');
    if (!box) return;
    var txt = box.querySelector('[data-fam47-fetch-err-txt]');
    if (txt && msg) txt.textContent = msg;
    box.hidden = false;
  }
  function hideError() {
    var box = document.querySelector('[data-fam47-fetch-err]');
    if (box) box.hidden = true;
  }

  /* ===== fetchState con cache · render instantáneo si hay cache, refresh background ===== */
  function fetchState() {
    var cached = readStateCache();
    if (cached) {
      applyState(cached);
      /* refresh en background · sin loader */
      apiCall('state', { method: 'GET' })
        .then(function (res) {
          if (res.ok && res.body && res.body.ok && res.body.state) {
            writeStateCache(res.body.state);
            applyState(res.body.state);
          }
        })
        .catch(function () {});
      return;
    }
    /* sin cache · fetch normal con fallback */
    var resolved = false;
    apiCall('state', { method: 'GET' })
      .then(function (res) {
        resolved = true;
        if (res.ok && res.body && res.body.ok && res.body.state) {
          writeStateCache(res.body.state);
          applyState(res.body.state);
        } else {
          revealReto();
        }
      })
      .catch(function () {
        resolved = true;
        revealReto();
        showError('Sin conexión · reintenta en unos segundos');
      });
    setTimeout(function () {
      if (!resolved) {
        revealReto();
        showError('Tardando más de lo normal · reintenta si no carga');
      }
    }, REVEAL_FALLBACK_MS);
  }

  /* ===== Skeleton handover ===== */
  function hideSkeleton() {
    if (skel) skel.hidden = true;
  }
  /* V2.5 · referencia al overlay cinema · activo solo cuando dashboard está unlocked */
  var cinema = document.querySelector('[data-dash-cinema]');
  function showCinema() { if (cinema) cinema.hidden = false; }
  function hideCinema() { if (cinema) cinema.hidden = true; }

  function reveal(id) {
    if (gate) gate.hidden = true;
    dash.hidden = false;
    hideSkeleton();
    document.documentElement.classList.add('fam47-unlocked');
    document.body.classList.remove('fam47-locked');
    applyName(id);
    fetchState();
    /* V1.4 · arranca el countdown del pre-launch teaser si está configurado */
    initTeaser();
    /* V2.5 · activa cinema layer (partículas + fog + grid) */
    showCinema();
  }
  function lockAndShow() {
    if (gate) gate.hidden = false;
    dash.hidden = true;
    hideSkeleton();
    document.body.classList.add('fam47-locked');
    /* V2.5 · cinema layer oculto durante gate (cero interferencia visual) */
    hideCinema();
    var idInput = gate && gate.querySelector('[name="fam47id"]');
    if (idInput) setTimeout(function () { try { idInput.focus(); } catch (e) {} }, 30);
  }
  function tagCustomer(famId) {
    try {
      apiCall('unlock', {
        method: 'POST',
        body: JSON.stringify({
          email: CUSTOMER_EMAIL,
          firstName: CUSTOMER_FNAME,
          fam47Id: famId || ''
        })
      }).catch(function () {});
    } catch (e) {}
  }

  /* Logout cleanup · barre todas las caches fam47:* */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    var a = (t && t.closest) ? t.closest('a[href*="/account/logout"]') : null;
    if (!a) return;
    try {
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var k = localStorage.key(i);
        if (k && k.indexOf('fam47:') === 0) localStorage.removeItem(k);
      }
    } catch (e) {}
  }, true);

  /* ===== Init: gate cache válida → reveal, else lockAndShow ===== */
  var cached = readUnlockCache();
  if (window.FAM47_TOKEN) {
    reveal((cached && cached.id) || '');
  } else if (cached && cached.key === currentKey()) {
    reveal(cached.id);
  } else {
    /* 47X: sin token ni sesión → la pantalla IG (atletas-auth-47x.js) gestiona el acceso; NO mostrar el gate viejo */
  }

  /* ===== Gate form (password rotativa) ===== */
  if (gate) {
    var form = gate.querySelector('[data-fam47-form]');
    var err  = gate.querySelector('[data-fam47-err]');
    var idInput  = gate.querySelector('[name="fam47id"]');
    var pwdInput = gate.querySelector('[name="password"]');

    function showGateError(msg) {
      if (msg && err) err.textContent = msg;
      if (err) err.hidden = false;
      gate.classList.remove('is-shake');
      void gate.offsetWidth;
      gate.classList.add('is-shake');
    }

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (!idInput || !pwdInput) return;
        var id = sanitizeId(idInput.value);
        var typed = (pwdInput.value || '').trim().toUpperCase();
        if (id.length < 2) {
          showGateError('Tu ID debe tener al menos 2 caracteres');
          idInput.focus();
          return;
        }
        if (!isPasswordValid(typed)) {
          showGateError('Contraseña incorrecta · revisa el grupo FAM47');
          pwdInput.select();
          return;
        }
        if (err) err.hidden = true;
        writeUnlockCache(currentKey(), id);
        tagCustomer(id);
        reveal(id);
      });
    }
  }

  /* ===== COMPLETE reto · hot update (sin location.reload) ===== */
  function readFamId() {
    try {
      var raw = localStorage.getItem(STORAGE_UNLOCK);
      if (raw) { var o = JSON.parse(raw); return (o && o.id) ? o.id : ''; }
    } catch (e) {}
    return '';
  }
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('[data-atletas-complete]');
    if (!btn || btn.disabled) return;
    var retoEl = document.querySelector('[data-atletas-reto]');
    if (!retoEl) return;
    var retoHandle = retoEl.getAttribute('data-reto-handle');
    var retoTitulo = retoEl.getAttribute('data-reto-titulo') || '';
    var retoDesc   = retoEl.getAttribute('data-reto-desc') || '';
    var retoPts    = parseInt(retoEl.getAttribute('data-reto-puntos'), 10) || 0;

    btn.disabled = true;
    btn.classList.add('is-loading');
    var label = btn.querySelector('span');
    function setLabel(text) { if (label) label.textContent = text; }
    setLabel('PROCESANDO...');

    apiCall('complete', {
      method: 'POST',
      body: JSON.stringify({
        retoHandle: retoHandle,
        retoTitulo: retoTitulo,
        retoDescripcion: retoDesc,
        email: CUSTOMER_EMAIL,
        firstName: CUSTOMER_FNAME,
        fam47Id: readFamId()
      })
    })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (res.status === 200 && res.body && res.body.ok) {
          /* === Hot update (sin reload) === */
          btn.classList.add('is-done');
          var nuevoPts = res.body.nuevoPuntos != null ? res.body.nuevoPuntos : 0;
          var nuevaRacha = res.body.nuevaRacha != null ? res.body.nuevaRacha : 0;
          setLabel('+' + retoPts + ' XP · COMPLETADO ✓');
          retoEl.classList.add('is-done');

          /* === V1.1 · Snapshot ANTES de actualizar para detectar deltas === */
          var oldPtsEl = document.querySelector('[data-atletas-puntos]');
          var oldRaEl  = document.querySelector('[data-atletas-racha]');
          var oldPts = oldPtsEl ? (parseInt(oldPtsEl.textContent, 10) || 0) : 0;
          var oldRa  = oldRaEl  ? (parseInt(oldRaEl.textContent,  10) || 0) : 0;
          var deltaXp = nuevoPts - oldPts;
          var deltaRacha = nuevaRacha - oldRa;
          var levelCrossed = detectLevelUp(oldPts, nuevoPts);

          /* === V1.2 · Snapshot de achievements ANTES de update === */
          var achBefore = snapshotAchievements();

          /* Replace botón por done card · misma UX que SSR reto_done_today */
          applyRetoDoneCard({
            puntos: retoPts,
            titulo: retoTitulo,
            descripcion: retoDesc
          });
          /* V1.2 · reto card pulsa verde success */
          pulseRetoCard(retoEl);

          /* === V1.2 · Count-up XP + RACHA (en lugar de setText directo) === */
          countUp(oldPtsEl, oldPts, nuevoPts, 1200);
          countUp(oldRaEl,  oldRa,  nuevaRacha, 800);
          applyXpBar(nuevoPts);
          /* V1.2 · XP bar glow del segmento que se llenó */
          pulseXpBar();
          /* V1.2 · racha update escala de fuego */
          setRachaLevel(nuevaRacha);

          /* === V1.1 · Celebración (floating XP/+1d + pulse HUD) === */
          celebrate(deltaXp, deltaRacha);

          /* === V1.2 · Logros recién desbloqueados (re-evaluate después de bio stats) === */
          var newAchState = {
            puntos: nuevoPts,
            racha: nuevaRacha,
            retos_completados: (res.body.state && res.body.state.retos_completados) || null,
            mes_actual_completo: !!(res.body.state && res.body.state.mes_actual_completo)
          };
          if (newAchState.retos_completados) {
            applyBioStats(newAchState);
            applyAchievements(newAchState);
          }
          /* V1.3 · re-evalúa objetivos dinámicos con el nuevo state */
          applyNextAch(newAchState);
          setStreakForecast(nuevaRacha);
          var newCurLv = getNivel(nuevoPts);
          applyNextBene(newCurLv.current.name);
          var newlyUnlocked = detectNewAchievements(achBefore);
          newlyUnlocked.forEach(function (ach, i) {
            setTimeout(function () { celebrateAchievement(ach); }, 1200 + i * 600);
          });

          /* === V1.1 + V1.2 · Toast level-up + burst overlay si cruzó threshold === */
          if (levelCrossed) {
            setTimeout(function () { spawnLevelBurst(levelCrossed); }, 650);
            setTimeout(function () { showLevelUpToast(levelCrossed); }, 1400);
          }

          /* Update bio + achievements + banners con estado nuevo */
          var newState = {
            puntos: nuevoPts,
            racha: nuevaRacha,
            retos_completados: (res.body.state && res.body.state.retos_completados) || null,
            mes_actual_completo: !!(res.body.state && res.body.state.mes_actual_completo)
          };
          if (newState.retos_completados) {
            applyBioStats(newState);
            applyAchievements(newState);
            /* Update cache para que siguiente navegación tenga el estado nuevo */
            writeStateCache(newState);
          } else {
            /* Backend no devolvió state completo · invalidar para fetch fresh next time */
            invalidateStateCache();
          }
          return;
        }
        if (res.status === 409) {
          btn.classList.add('is-done');
          setLabel('YA LO HICISTE HOY ✓');
          invalidateStateCache();
          return;
        }
        if (res.status === 401) {
          setLabel('SESIÓN EXPIRADA · INICIA SESIÓN');
          setTimeout(function () {
            location.href = LOGIN_URL + '?return_url=/pages/atletas';
          }, 900);
          return;
        }
        btn.disabled = false;
        btn.classList.add('is-error');
        setLabel('ERROR · INTENTA DE NUEVO');
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setLabel('SIN CONEXIÓN · REINTENTAR');
      });
  });
})();
